import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {CdkListbox, CdkOption} from '@angular/cdk/listbox';
import {MatExpansionModule} from '@angular/material/expansion';
import {ChangeDetectionStrategy, signal} from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';

import {
  CdkDragDrop,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem,
 
} from '@angular/cdk/drag-drop';
import { CreateMyMenuService } from './createmymenu.service';

@Component({
  selector: 'app-createmymenu',
  imports: [DragDropModule,CommonModule, CdkDropList, CdkDrag,CdkDropListGroup, CdkListbox,
    CdkOption,FormsModule,MatExpansionModule, MatListModule,MatButtonModule],
  templateUrl: './createmymenu.component.html',
  styleUrl: './createmymenu.component.css',
  providers: [CreateMyMenuService],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})



export class CreatemymenuComponent implements OnInit {
  foods: { event:string,type: string, text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  welcomedrink:{ event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  vegstarter: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  nvegstarter: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  chatcounters: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  grill: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  oriental: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  soup: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  salad: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  frieditem: { event:string,type: string, text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  bread: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  rice: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  dal: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  vegmain: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  nonchickenmain: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  nonfishmain: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  nonmuttonmain: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  dessert: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  chutney: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  userMenu: { event:string,type: string,  text: string, image: string, priceperplate: string ,typedesc: string}[] = [];
  order: readonly string[] = [];
  readonly panelOpenState = signal(false);
  constructor(private createmymenuService: CreateMyMenuService) {}

  ngOnInit(): void {
    
    this.createmymenuService.getFoods().subscribe(
      (data) => {
        this.foods = data;
        this.welcomedrink = this.foods.filter((food) => food.event==="Wedding" && food.type === 'wdrink');
        this.vegstarter = this.foods.filter((food) => food.event==="Wedding" && food.type === 'strtveg');
        this.nvegstarter = this.foods.filter((food) => food.event==="Wedding" && food.type === 'strtnveg');
        this.chatcounters = this.foods.filter((food) => food.event==="Wedding" && food.type === 'lcc');
        this.grill = this.foods.filter((food) => food.event==="Wedding" && food.type === 'lgkc');
        this.oriental = this.foods.filter((food) => food.event==="Wedding" && food.type === 'loc');
        this.soup = this.foods.filter((food) => food.event==="Wedding" && food.type === 'soup');
        this.salad = this.foods.filter((food) => food.event==="Wedding" && food.type === 'salad');
        this.frieditem = this.foods.filter((food) => food.event==="Wedding" && food.type === 'fitem');
        this.bread = this.foods.filter((food) => food.event==="Wedding" && food.type === 'bread');
        this.rice = this.foods.filter((food) => food.event==="Wedding" && food.type === 'rnb');
        this.dal = this.foods.filter((food) => food.event==="Wedding" && food.type === 'dal');
        this.vegmain = this.foods.filter((food) => food.event==="Wedding" && food.type === 'vmc');
        this.nonchickenmain = this.foods.filter((food) => food.event==="Wedding" && food.type === 'nvcmc');
        this.nonfishmain = this.foods.filter((food) => food.event==="Wedding" && food.type === 'nvfmc');
        this.nonmuttonmain = this.foods.filter((food) => food.event==="Wedding" && food.type === 'nvmmc');
        this.dessert = this.foods.filter((food) => food.event==="Wedding" && food.type === 'dessert');
        this.chutney = this.foods.filter((food) => food.event==="Wedding" && food.type === 'chatni');
          
       
      },
      (error) => {
        console.error('Error fetching foods:', error);
      }
    );
  }


  drop(event: CdkDragDrop<{event:string, type: string, text: string, image: string, priceperplate: string,typedesc: string}[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  
}